module.exports = __webpack_public_path__ + "static/homepage-hero-bg-t-ad9f99f8975ec3463fb74f5b0871decc.jpg";